module.exports = __webpack_public_path__ + "img/slika29.fc12df62.jpg";